import { Box } from '@mui/material';
import { styled, type Theme } from '@mui/material/styles';

export type StatusDotColor =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'primary'
  | 'disabled';

type DotStyledProps = {
  dotColor: StatusDotColor;
};

const resolveDotColor = (theme: Theme, dotColor: StatusDotColor) => {
  if (dotColor === 'disabled') {
    return theme.palette.text.disabled;
  }

  return theme.palette[dotColor]?.main;
};

export const DotStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'dotColor',
})<DotStyledProps>(({ theme, dotColor }) => ({
  width: theme.spacing(1),
  height: theme.spacing(1),
  borderRadius: '50%',
  backgroundColor: resolveDotColor(theme, dotColor),
}));
